import { $apiWithoutClient } from '../service';

export const getUniversityCourseSelect =
  ({
    universityId,
    courseSlug,
    universitySlug
  }: {
    universityId?: string;
    courseSlug?: string;
    universitySlug?: string;
  }) =>
  async () => {
    const { data } = await $apiWithoutClient.get('/v2/university/courses', {
      params: {
        university_id: universityId,
        course_slug: courseSlug,
        university_slug: universitySlug
      }
    });

    return { univerCourse: data };
  };
